module.exports = __webpack_public_path__ + "static/media/mgo_3_4_ws.5e4d6e27.pdf";